import { ContractStep } from "src/api/contract/contract-types";

export const INVITEABLE_CONTRACT_STEP = [
  ContractStep.CONTRACT_ACCEPT, // 계약체결
  ContractStep.USE_APPROVAL, // 이용승인
  ContractStep.USE_PROGRESS, // 이용중
  ContractStep.TERMINATE_RECEIVED, // 해지접수
];
